import PagedCollection    from '@widesk-core/models/PagedCollection';
import ClientRequestModel from '@models/account/ClientRequestModel';

export default async function countClientRequests(filters: ModelFilters<ClientRequestModel>) {
	const requests = new PagedCollection(ClientRequestModel).setItemsPerPage(1);
	requests.setFilters(filters);
	await requests.list();

	return requests.total;
}
